module.exports = __webpack_public_path__ + "static/media/favicon.39afb365.ico";